import React from "react";
import type { SettingSourceListProps } from "./SettingSourceList.types";
import { Action, Body, Heading, Label, List, Root, Row, Source, Value } from "./SettingSourceList.styles";

/** Rows of "setting, its value, and where the value comes from", each with an optional action link. */
export const SettingSourceList: React.FC<SettingSourceListProps> = ({ id, heading, rows }) => (
  <Root aria-labelledby={heading ? `${id}-heading` : undefined} data-testid={id}>
    {heading && <Heading id={`${id}-heading`}>{heading}</Heading>}
    <List>
      {rows.map((row) => (
        <Row key={row.id} data-testid={`${id}-${row.id}`}>
          <Label>{row.label}</Label>
          <Body>
            <Value>{row.value}</Value>
            <Source $overridden={Boolean(row.overridden)}>{row.source}</Source>
          </Body>
          {row.actionLabel && row.onAction && (
            <Action type="button" onClick={row.onAction}>
              {row.actionLabel}
            </Action>
          )}
        </Row>
      ))}
    </List>
  </Root>
);

export default SettingSourceList;
